export default "__VITE_PUBLIC_ASSET__042e0586__"